import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import store from '@/store';
import { Roles } from '@/typings/user';
import StoreType from '@/typings/storeType';

import CButton from '@/components/shared/CButton';
import CanvasToolbarTopPreviewButtons from './previews/CanvasToolbarTopPreviewButtons.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CanvasToolbarTop',
  setup(__props) {

const canvas = computed(() => {
    return store.state.storeLayers?.canvas;
});

const isPreMergeFlow = computed(() => !!store.state.storeLayers?.flags?.isPreMergeFlow);

const canModifyPreview = computed(
    () => !store.state.storeLayers?.flags?.hideMultiPreviewActions && !isPreMergeFlow.value
);

const isFeatureEnabled = computed(() => {
    const user = store.state.user;
    if (!user) return false;

    const roles = user.AccessRoles?.Serialized.split(',');

    const isAdmin = roles?.includes(Roles.ADMIN);
    const impersonatedFromAdminUser = user.ImpersonatedFromAdminUser;
    const isMultiPreview = roles?.includes(Roles.MULTI_PREVIEW);
    const stores = store.state.user?.Stores || [];
    const multiPreviewStoreTypes = [StoreType.Shopify, StoreType.Etsy, StoreType.TikTok, StoreType.WooCommerce];
    const hasMultiPreviewStore = stores.some((store) => multiPreviewStoreTypes.includes(store.Type));

    return Boolean(isAdmin || impersonatedFromAdminUser || isMultiPreview || hasMultiPreviewStore);
});

const onAddPreview = () => {
    if (!canvas.value) return;
    canvas.value.addPreview();
};

return { __sfc: true,canvas, isPreMergeFlow, canModifyPreview, isFeatureEnabled, onAddPreview, CButton, CanvasToolbarTopPreviewButtons }
}

})